import { render, staticRenderFns } from "./TabellaIscrizioni.vue?vue&type=template&id=c0fbd35c&scoped=true&"
import script from "./TabellaIscrizioni.vue?vue&type=script&lang=js&"
export * from "./TabellaIscrizioni.vue?vue&type=script&lang=js&"
import style0 from "./TabellaIscrizioni.vue?vue&type=style&index=0&id=c0fbd35c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fbd35c",
  null
  
)

export default component.exports